export default {
  "name": "Partió de mí un barco llevándome",
  "slug": "partio-de-mi-un-barco-llevandome",
  "path": "/partio-de-mi-un-barco-llevandome",
  "componentName" : "PartioDeMiUnBarcoLlevandome",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}